module.exports = __webpack_public_path__ + "img/1463020814.1560ae16.jpg";